import React from "react";
import { ProducerLabelTemplate } from "themes/common/components/producer";

function ProducerLabel(props) {
    return <ProducerLabelTemplate {...props} />;
}

export default ProducerLabel;
